import React from 'react';
import {Status, Title, Table, TableHeader, TableColumn} from './styles';
import {OrderProps, OrderStatus} from 'modules/orders/types';
import useOpenedOrderStatus from 'modules/orders/hooks/use-opened-order-status';
import OrderRow from './components/order-row';

const orderStatusTranslations = {
  awaiting_payment: 'Aguardando pagamento',
  opened: 'Novo pedido',
  preparing: 'Em preparo',
  ready_to_pickup: 'Pronto para retirada',
  ready_to_delivery: 'Pronto para entrega',
  accepted: 'Aceito pelo entregador',
  delivering: 'Em entrega',
  arrival: 'Chegou no endereço',
  finished: 'Finalizado',
  canceled: 'Cancelado',
} as unknown as Record<keyof typeof OrderStatus, string>;

export const orderStatusColors = {
  awaiting_payment: '#a6a6a6',
  opened: '#fbe931',
  preparing: '#e1b805',
  ready_to_pickup: '#ffa520',
  ready_to_delivery: '#ff7420',
  delivering: '#003d20',
  finished: '#08bf64',
  canceled: '#ff3131',
  me: '#0096c7',
  available: '#ff7420',
  arrival: '#027a3f',
} as unknown as Record<keyof typeof OrderStatus, string>;

interface Props {
  status: OrderStatus;
  data: OrderProps[];
}

const OrderStatusList: React.FC<Props> = ({status, data}) => {
  const {openedOrderStatus, setOpenedOrderStatus} = useOpenedOrderStatus();

  const handleToggleOpenedStatus = (status: string) => {
    const isStatus = openedOrderStatus.includes(status);

    const newStatus = isStatus
      ? openedOrderStatus.filter((someStatus) => someStatus !== status)
      : [...openedOrderStatus, status];

    setOpenedOrderStatus(newStatus);
  };

  const buttonColor = orderStatusColors[status];
  const rowColor = `${buttonColor}20`;
  const rowHoverColor = `${buttonColor}60`;

  return (
    <Status>
      <Title
        style={{
          color:
            status === 'preparing' || status === 'opened' ? 'black' : 'white',
        }}
        color={buttonColor}
        onClick={() => handleToggleOpenedStatus(status)}>
        {orderStatusTranslations[status]} ({data.length})
      </Title>
      {openedOrderStatus.includes(status) && (
        <Table>
          <TableHeader>
            <TableColumn>Id</TableColumn>
            <TableColumn>Cliente</TableColumn>
            <TableColumn>Forma de pagamento</TableColumn>
            <TableColumn>Empresa</TableColumn>
            <TableColumn>Entregador</TableColumn>
            <TableColumn>Data</TableColumn>
            <TableColumn>Atualizado em</TableColumn>
            <TableColumn>Total</TableColumn>
            <TableColumn>Taxa de entrega</TableColumn>
            <TableColumn>Ações</TableColumn>
          </TableHeader>
          {data.map((order) => (
            <OrderRow
              key={order.id}
              {...{
                ...order,
                ...{
                  rowColor,
                  rowHoverColor,
                },
              }}
            />
          ))}
        </Table>
      )}
    </Status>
  );
};

export default OrderStatusList;
